<div class="users-header">
  <wm-common-text [data]="{ text: 'Users' }" class="header"></wm-common-text>
</div>

<!-- Added by Amisha on 2026-09-18.
     Reason: match GeoPermits by showing each Users subtab only when its corresponding access is available. -->
<div class="tabs">
  <a
    *ngIf="clientAdmin.canEditUsers"
    class="tab"
    routerLink="list"
    [class.active]="isTabActive('list')"
  >
    List
  </a>

  <a
    *ngIf="clientAdmin.canEditRoles"
    class="tab"
    routerLink="roles"
    [class.active]="isTabActive('roles')"
  >
    Roles
  </a>

  <a
    *ngIf="clientAdmin.canInviteUsers"
    class="tab"
    routerLink="invitations"
    [class.active]="isTabActive('invite')"
  >
    Invite
  </a>
</div>

<div class="tab-content">
  <router-outlet></router-outlet>
</div>
